type DiagnosticKind = 'runtime_error' | 'unhandled_rejection' | 'api_error';

export interface DiagnosticEvent {
  kind: DiagnosticKind;
  at: string;
  message: string;
  detail?: unknown;
}

const MAX_EVENTS = 20;
const events: DiagnosticEvent[] = [];
let installed = false;

function push(event: DiagnosticEvent) {
  events.push(event);
  if (events.length > MAX_EVENTS) events.shift();
}

function safeMessage(value: unknown): string {
  if (value instanceof Error) return value.message;
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

export function installDiagnosticListeners(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event) => {
    push({
      kind: 'runtime_error',
      at: new Date().toISOString(),
      message: event.message,
      detail: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    push({
      kind: 'unhandled_rejection',
      at: new Date().toISOString(),
      message: safeMessage(event.reason),
    });
  });
}

export function recordApiError(input: {
  path: string;
  status: number;
  statusText: string;
  body?: unknown;
}): void {
  push({
    kind: 'api_error',
    at: new Date().toISOString(),
    message: `${input.status} ${input.statusText} at ${input.path}`,
    detail: { path: input.path, status: input.status, body: input.body },
  });
}

export function getRecentDiagnostics(): DiagnosticEvent[] {
  return events.slice(-MAX_EVENTS);
}
